module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "titlepage",
      "id": "_idContainer000"
    }
  }, [_c('h1', {
    staticClass: "TitlePg1"
  }, [_vm._v("Let’s Brunch")]), _vm._v(" "), _c('h2', {
    staticClass: "TitlePg2"
  }, [_vm._v("100 Recipes for the Best Meal of the Week")]), _vm._v(" "), _c('h3', {
    staticClass: "TitlePg3"
  }, [_vm._v("Belinda Smith-Sullivan")]), _vm._v(" "), _c('p', {
    staticClass: "TitlePg4"
  }, [_vm._v("Photographs by Susan Barnson Hayward")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Gibbs Smith logo",
      "src": "image/logo.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of Blueberry-Almond Puff Tarts.",
      "src": "image/Brunch-Blueberry_Tarts-2-6-C.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "dedication",
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "dedication ParaOverride-1"
  }, [_vm._v("To my husband Dan with all my love, respect, and admiration.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "copyright-page",
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "CIP"
  }, [_vm._v("Digital Edition 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "CIP nospace"
  }, [_vm._v("Text © 2020 Belinda Smith-Sullivan")]), _vm._v(" "), _c('p', {
    staticClass: "CIP nospace"
  }, [_vm._v("Photographs © 2020 Susan Barnson Hayward")]), _vm._v(" "), _c('p', {
    staticClass: "CIP nospace"
  }, [_vm._v("Author Photograph by Adrion Bell")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Food Styling by Corrine Miller")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP nospace"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "CIP nospace"
  }, [_vm._v("Gibbs Smith")]), _vm._v(" "), _c('p', {
    staticClass: "CIP nospace"
  }, [_vm._v("P.O. Box 667")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Layton, Utah 84041")]), _vm._v(" "), _c('p', {
    staticClass: "CIP nospace"
  }, [_vm._v("1.800.835.4993 orders")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("www.gibbs-smith.com")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Library of Congress Control Number: 2020933152")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("ISBN: 978-1-4236-5536-7 (e-book)")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "Photo of a fried egg in a cast-iron skillet.",
      "src": "image/Brunch-Croque_Extra-1_B.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f68ad9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lets-Brunch-Interiors_D.vue
// module id = 60
// module chunks = 0